<template>
	<div class="rebag">
		<HeaDer></HeaDer>
		<div class="bgcontent">
			<el-card class="box-card">
				<div class='btnp'>
					<p :class="isMshow==true?'active':''" @click="isMshow=true">
						手机验证
					</p>
					<p :class="isMshow==false?'active':''" @click="isMshow=false">
						密保验证
					</p>
				</div>
				
				<div class="chongzhi"  v-if="isMshow">
					<el-form :model="formData" status-icon :rules="rules" ref="ruleForm" label-width="100px"
						class="demo-ruleForm">
						<el-form-item label="姓名" prop="userName">
							<el-input placeholder="请输入姓名,中间不能有空格" v-model="formData.userName"></el-input>
						</el-form-item>
						<el-form-item label="身份证号" prop="idCard">
							<el-input v-model="formData.idCard" placeholder="请输入18位身份证号"></el-input>
						</el-form-item>
						<el-form-item label="手机号" prop="phone" class="yanzhengma1">
							<el-input placeholder="请输入手机号" v-model="formData.phone"></el-input>
							<span class="yanzhengma" @click="getcode()" v-if="!codedisable">获取验证码</span>
							<span class="yanzhengma" v-if="codedisable">{{ djs }}秒后重新获取</span>
						</el-form-item>
						<el-form-item label="验证码" prop="code">
							<el-input placeholder="请输入验证码" v-model="formData.code"></el-input>
						</el-form-item>
						<p class="zhuyia">注：考生填写手机验证码，才能进行密码重置</p>
						<el-form-item>
							<el-button style="padding: 10px 26px" @click="cancelsubmit()">取消</el-button>
							<el-button type="primary" @click="chongzhimima()" style="padding: 10px 26px">确认</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="chongzhi" v-else>
					<el-form :model="formData" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="姓名" prop="userName">
							<el-input placeholder="请输入姓名" v-model="formData.userName"></el-input>
						</el-form-item>
						<el-form-item label="身份证号" prop="idCard">
							<el-input v-model="formData.idCard" placeholder="请输入15位或18位身份证号"></el-input>
						</el-form-item>
						<el-form-item label="问题"  prop="forgetQuestion">
							<el-select v-model="formData.forgetQuestion" placeholder="请选择" style="width:100%;">
								<el-option v-for="(item,index) in options" :key="index" :label="item.dictLabel" :value="item.dictLabel">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="答案" prop="forgetAnswer">
							<el-input placeholder="请输入问题答案" v-model="formData.forgetAnswer"></el-input>
						</el-form-item>
						<p class="zhuyia">注：考生需答对密码保护问题，才能进行密码重置</p>
						<el-form-item>
							<el-button  @click="cancelsubmit" style="padding:10px 26px;">取消</el-button>
							<el-button type="primary" @click="chongzhimima" style="padding:10px 26px;">确认</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-card>
		</div>
		<FooTer></FooTer>
	</div>
</template>

<script>
	import HeaDer from "../components/common/header.vue";
	import FooTer from "../components/common/footer.vue";
	import {
		dictdataconfig,
		getPhoneCode,
		checkPhoneCode,
		seeuserinfo
	} from "@/api/api";
	export default {
		name: "fortpas",
		components: {
			HeaDer,
			FooTer,
		},
		data() {
			const idCardValidity = (rule, code, callback) => {
				var city = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江 ",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北 ",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏 ",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门",
					91: "国外 ",
				};
				var tip = "";
				var pass = true;

				if (
					!code ||
					!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
						code
					)
				) {
					tip = "身份证号格式错误";
					pass = false;
				} else if (!city[code.substr(0, 2)]) {
					tip = "地址编码错误";
					pass = false;
				} else {
					// 18位身份证需要验证最后一位校验位
					if (code.length === 18) {
						code = code.split("");
						// ∑(ai×Wi)(mod 11)
						// 加权因子
						var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
						// 校验位
						var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
						var sum = 0;
						var ai = 0;
						var wi = 0;
						for (var i = 0; i < 17; i++) {
							ai = code[i];
							wi = factor[i];
							sum += ai * wi;
						}
						// var last = parity[sum % 11];
						if (parity[sum % 11] != code[17]) {
							tip = "校验位错误";
							pass = false;
						}
					}
				}
				if (!pass) {
					callback(new Error(tip));
				} else {
					callback();
				}
				// if (!pass) alert(tip)
				// return pass
			};
			return {
				isMshow:true,
				djs: 60,
				codedisable: false,
				options: [],
				formData: {
					forgetAnswer: null,
					forgetQuestion: null,
					idCard: "",
					userName: "",
					phone: "",
					code: "",
				},
				rules: {
					userName: [{
						required: true,
						message: "请输入姓名",
						trigger: "blur"
					}],
					phone: [{
						required: true,
						message: "请选择手机号",
						trigger: "blur"
					}],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur"
					}],
					idCard: [{
							required: true,
							message: "请输入身份证号",
							trigger: "blur"
						},
						{
							validator: idCardValidity,
							trigger: "blur",
						},
					],
				},
			};
		},
		created() {
			dictdataconfig({
				objType: "question"
			}).then((res) => {
				this.options = res.data.data;
			});
		},
		methods: {
			getcode: function() {
				console.log("1111111");
				if (this.formData.userName == "") {
					this.$message({
						showClose: true,
						message: "请输入姓名！",
						type: "error",
					});
					return;
				}
				if (this.formData.idCard == "") {
					this.$message({
						showClose: true,
						message: "请输入身份证！",
						type: "error",
					});

					return;
				}
				if (this.formData.phone == "") {
					this.$message({
						showClose: true,
						message: "请输入手机号！",
						type: "error",
					});

					return;
				}
				let data1 = {
					userName: this.formData.userName,
					idCard: this.formData.idCard,
					phone: this.formData.phone,
					examinationId: this.$store.state.examid,
				};
				getPhoneCode(data1).then((res) => {
					console.log(res);
					if (res.data.code == 0) {
						this.$message({
							showClose: true,
							message: res.data.msg,
							type: "success",
						});

						this.codedisable = true;
						let t = setInterval(() => {
							if (this.djs == 0) {
								clearInterval(t);
								this.codedisable = false;
								this.djs = 60;
							}
							this.djs--;
						}, 1000);
					} else {
						this.$message({
							showClose: true,
							message: res.data.msg,
							type: "error",
						});
					}
				});
			},
			cancelsubmit() {
				this.$router.back(-1);
			},
			chongzhimima() {
				if(this.isMshow==true){
					this.$refs["ruleForm"].validate((valid) => {
						if (valid) {
							checkPhoneCode({
								code: this.formData.code,
								idCard: this.formData.idCard,
								phone: this.formData.phone,
								examinationId: this.$store.state.examid,
							}).then((res) => {
								console.log(res);
								if (res.data.code == 0) {
									let data = this.formData;
									data["signUpNo"] = res.data.data.signUpNo;
									data["id"] = res.data.data.id;
									console.log(data);
					
									this.$router.push({
										path: "/chongzhipas",
										query: data,
									});
								} else {
									this.$message({
										showClose: true,
										message: res.data.msg,
										type: "error",
									});
								}
							});
						}
					});
				}else{
					this.$refs['ruleForm'].validate(valid => {
						if (valid) {
							var obj = JSON.parse(JSON.stringify(this.formData))
							obj.examinationId=this.$store.state.examid,
							seeuserinfo(obj).then(res => {
								if (res.data.code == 0) {
									let data = this.formData;
									data.signUpNo = res.data.data[0].signUpNo;
									data.id = res.data.data[0].id;
									console.log(data);
														
									this.$router.push({
										path: "/chongzhipas",
										query: data,
									});
								} else {
									this.$message({
										showClose: true,
										message: '信息输入错误，请确认后再试！',
										type: 'error'
									});
								}
							})
					
						}
					})
				}
				
			},
		},
	};
</script>

<style scoped>
	.btnp {
		display: flex;
		justify-content: center;
	}

	.btnp p {
		width: 200px;
		background-color: #EBEEF5;
		color: #303133;
		text-align: center;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		/* font-weight: bold; */
	}

	.btnp .active {
		background-color: #409EFF;
		color: #fff;
		font-weight: bold;
	}

	.yanzhengma1 {
		position: relative;
	}

	.yanzhengma {
		position: absolute;
		top: 0;
		right: 0;
		padding: 0px 10px;
		font-size: 12px;
		color: rgb(101, 177, 255);
	}

	header {
		height: 120px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		margin-top: -20px;
	}

	.bap {
		color: #ffffff;
		float: left;
		line-height: 130px;
		letter-spacing: 2px;
		text-shadow: #333333 0px 0px 5px;
		font-size: 26px;
	}

	.bacontent {
		width: 1200px;
		margin: 0 auto;
	}

	.baimg {
		float: right;
		margin-top: 50px;
	}

	.bgcontent {
		margin-top: 40px;
	}

	.box-card {
		margin: 0 auto;
		width: 1200px;
		margin: 0 auto;
		min-height: 620px;
	}

	.yuetitle {
		font-size: 20px;
		color: #000000;
		font-weight: bold;
		margin-top: 80px;
	}

	.chongzhi {
		width: 400px;
		margin: 0 auto;
	}

	.zhuyia {
		color: #df0000;
		font-size: 14px;
		margin-left: 32px;
		margin-top: -5px;
		margin-bottom: 30px;
	}
</style>